// extracted by mini-css-extract-plugin
export default {"container":"hF-z","dimension":"iF-z","dimensionLabels":"jF-z"};